<template>
  <Component :is="component" :class="classes" :modules="modules" />
</template>

<script>
import ProductCarousel from "./ProductCarousel.vue";
import ProductHoverCards from "./ProductHoverCards.vue";

export default {
  props: {
    modules: {
      type: Object,
      required: true
    }
  },
  computed: {
    component() {
      const components = {
        "Product Carousel": ProductCarousel,
        "Product Hover Cards": ProductHoverCards
      };
      return components[this.modules.type];
    },
    classes() {
      const classes = {
        "Product Carousel": "module module--product-carousel relative",
        "Product Hover Cards": "module module--product-hover-cards relative"
      };
      return `module ${classes[this.modules.type]} w-full`;
    }
  }
};
</script>
